import script from "./AuthShell.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthShell.vue?vue&type=script&setup=true&lang=ts"

import "./AuthShell.vue?vue&type=style&index=0&id=421b783e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-421b783e"]])

export default __exports__